export default "__VITE_ASSET__8815nsUH__"